export const spinnerTheme = {
  strokeColor: '--medkit-spinner-stroke-color',
  strokeColorPrimary: '--medkit-spinner-stroke-color-primary',
}
